var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bui-sidebar',{key:_vm.$store.state.user.id,attrs:{"menus":_vm.$store.state.user.is_admin == 1 ? _vm.menus : _vm.menusShort,"variant":_vm.currentVariant,"menus-bottom":_vm.menus_bottom,"sidebar-state":_vm.$store.state.sidebarState,"user":_vm.$store.state.user}})
}
var staticRenderFns = []

export { render, staticRenderFns }